import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomStaicAccordianStyles } from "@tSchaedlerYesco/Widgets/CustomStaticAccordian";
import React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CustomServiceStaicTemplateStyles {
    container?: InjectableCss;
    servicebanner?: InjectableCss;
    mainContent?: InjectableCss;
    content?: GridItemProps;
    pageNav?: GridItemProps;
}

export const CustomServiceStaicTemplateStyles: CustomServiceStaicTemplateStyles = {
    container: {
        css: css`
            div[id^="externalLink-wrapper"] {
                display: flex;
                > div[id^="externalLink"] {
                    background: rgb(39, 90, 168);
                    border: 2px solid rgb(39, 90, 168);
                    color: white;
                    min-height: 40px;
                    padding: 6px 21px;
                    text-align: center;
                    text-decoration: none;
                    display: inline-block;
                    width: auto !important;
                    > a[class^="StyledButton"] {
                        > span[class^="TypographyStyle"] {
                            color: rgb(255, 255, 255);
                            font-size: 15px;
                            font-weight: bold;
                        }
                    }
                    &:hover {
                        background: rgb(0, 0, 255);
                        border-color: rgb(60, 119, 210);
                    }
                }
            }
        `,
    },
    servicebanner: {
        css: css`
            margin: 0 -15px;
            position: relative;
            h1 {
                background-color: rgba(51, 51, 51, 0.5);
                color: rgb(255, 255, 255);
                line-height: 40px;
                top: 50%;
                position: absolute;
                height: 12.5vh;
                width: 350px;
                padding: 30px;
                display: flex;
                flex-direction: column;
                -webkit-box-pack: center;
                justify-content: center;
                text-align: center;
                font-weight: normal;
                font-size: 26px !important;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 145px;
                                line-height: 1;
                            `,
                            css`
                                width: 145px;
                                line-height: 1;
                            `,
                            css`
                                width: 310px;
                            `,
                            null,
                        ],
                        "minMax",
                    );
                }}
            }
            button {
                margin-top: 40px;
                margin-bottom: 10px;
            }
            [class^="Wrapper"] {
                div {
                    position: relative;
                }
            }
        `,
    },
    mainContent: {
        css: css`
            margin-top: 30px;
            [class^="GridOffset"] {
                width: 100%;
                margin: auto;
                [class^="GridItemStyle"] {
                    &:first-child {
                        padding-left: 0;
                    }
                    &:last-child {
                        padding-right: 0;
                    }
                }
            }
            [class^="GridItemStyle"] {
                &:nth-child(2) {
                    div {
                        width: 100%;
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            [class^="GridOffset"] {
                                [class^="GridItemStyle"] {
                                    padding: 0;
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "minMax",
                );
            }}
        `,
    },
    content: {
        width: [12, 12, 9, 9, 9],
        css: css`
            h2 {
                padding-bottom: 10px;
                font-size: 24px;
                margin-bottom: 0;
            }
            p {
                font-size: 14px;
                margin-bottom: 0;
            }
            h4 {
                font-size: 18px;
                margin-bottom: 5px !important;
            }
            h3 {
                font-size: 22px;
                color: rgb(54, 102, 177);
                margin-bottom: 5px !important;
            }
            video {
                width: 100%;
                height: 100%;
                object-fit: cover;
                margin: 30px 0 15px;
            }
            ul {
                margin-bottom: 0;
            }
        `,
    },
    pageNav: {
        width: [12, 12, 3, 3, 3],
        css: css`
            [class^="Wrapper"] {
                [class^="GridWrapper"] {
                    [class^="GridOffset"] {
                        width: 100%;
                    }
                    [class^="GridItemStyle"] {
                        margin-bottom: 30px;
                        background: #f0f9ff;
                    }
                }
                h4 {
                    padding: 10px 15px;
                    background: #f0f9ff;
                    border-bottom: 1px solid #d2dbea;
                    color: #3666b1;
                    font-weight: bold;
                    font-size: 15px;
                }
                p,
                li {
                    background: #f0f9ff;
                    padding: 5px 15px;
                    margin: 0;
                    font-size: 14px;
                    span {
                        color: #333333;
                    }
                }
                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
            }
        `,
    },
};
CustomStaicAccordianStyles.accordianContainer = {
    css: css`
        margin-top: 15px;
        [data-test-selector^="sectionHeader"] {
            button {
                background: #f2f3f5;
                border: 1px solid #d2dbea;
                padding: 10px;
                padding-left: 15px;
                transition: all 0.8s ease 0s;
                width: 100%;
                &:focus {
                    border-top: 1px solid #d2dbea;
                    border-left: 1px solid #d2dbea;
                    border-right: 1px solid #d2dbea;
                    padding-left: 15px;
                    padding: 10px;
                    padding-left: 15px;
                }
                svg {
                    color: #3666b1;
                }
            }
            [aria-expanded^="true"] {
                border-bottom: 2px solid #3666b1;
                padding: 10px;
                padding-left: 15px;
            }
            [aria-expanded^="false"] {
                border-bottom: 1px solid #d2dbea;
                padding: 10px;
                padding-left: 15px;
            }
            h4 {
                color: #3666b1;
                font-size: 16px;
            }
        }
        [data-test-selector^="sectionPanel"] {
            h4 {
                font-size: 14px;
                margin-bottom: 15px;
            }
            p {
                margin-bottom: 0;
            }
        }
    `,
};

const styles = CustomServiceStaicTemplateStyles;

const CustomServiceStaicTemplate: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CustomServiceStaicTemplate">
            <StyledWrapper {...styles.servicebanner}>
                <Zone contentId={id} zoneName="ServiceBanner" />
            </StyledWrapper>
            <GridContainer {...styles.mainContent}>
                <GridItem {...styles.content}>
                    <Zone contentId={id} zoneName="topcontent" />
                </GridItem>
                <GridItem {...styles.pageNav}>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="pageNav" />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomServiceStaicTemplate,
    definition: {
        displayName: "Custom Service Template",
        group: "Common",
    },
};

export default widgetModule;
